import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    getAreaListThunk,
    getNetworkInfoThunk,
    getUserMeThunk,
    postUserLoginThunk,
} from "tm-shared/api";
import { Option, UserRole } from "tm-shared/types";

import { UserState } from "./user.slice.types";

const initialState: UserState = {
    loggedInAt: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    id: "",
    roleName: "",
    role: null,
    availableRoles: [],
    routeName: "",
    regions: {},
    networks: {},
    team: {
        manager: {
            userId: "",
            email: "",
            fullName: "",
            phone: "",
            roleName: "",
        },
        teamId: "",
        teamName: "",
        mainRegionId: "",
        mainRegionName: "",
        route: {
            uuid: "",
            agentId: "",
            ownerId: "",
            name: "",
            description: null,
        },
    },
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setAvailableRoles(state, action: PayloadAction<Option[]>) {
            state.availableRoles = action.payload;
        },
        setLoggedInAt(state, action: PayloadAction<string>) {
            state.loggedInAt = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder

            .addCase(getUserMeThunk.fulfilled, (state, action) => {
                const { result } = action.payload;

                state.firstName = result.firstName;
                state.lastName = result.lastName;
                state.phone = result.phone;
                state.email = result.email;
                state.id = result.userId;
                state.roleName = result.authorizedRole.name;
                state.role = result.authorizedRole.slug as UserRole;
                state.routeName = result.routeName;
                state.team = result.team;

                localStorage.setItem("userId", result.userId);

                state.availableRoles = result.roles.map(({ name, slug }) => ({
                    label: name,
                    value: slug,
                }));
            })

            .addCase(getAreaListThunk.fulfilled, (state, action) => {
                state.regions = action.payload.result.reduce((acc, region) => {
                    acc[region.id] = region.name;
                    return acc;
                }, {});
            })
            .addCase(getNetworkInfoThunk.fulfilled, (state, action) => {
                state.networks = {
                    ...state.networks,
                    [action.payload.result.id]: action.payload.result.name,
                };
            })
            .addCase(postUserLoginThunk.fulfilled, (state, action) => {
                state.role = action.meta.arg.asRole ?? null;
            });
    },
});

export const { setAvailableRoles, setLoggedInAt } = userSlice.actions;

export default userSlice.reducer;
